import { values } from '../_helpers'

const _enum = {
  lemon: 0,
  gold: 1,
  amber: 2,
  brown: 3,
  pink: 4,
  pinkOrange: 5,
  orange: 6,
  purple: 7,
  ruby: 8,
  garnet: 9,
  tawny: 10
}

const colour = { ..._enum, name: 'colour', values: values(_enum) }

export {
  colour
}
